import { readStoredAccessToken } from "@/api/geniBackend";

const GOOGLE_ADS_SEND_TO = "AW-17947159775/kqwtCNqjnawcEN_Z7-1C";

type GtagFn = (command: string, ...args: unknown[]) => void;

type GtagWindow = Window & {
  dataLayer?: unknown[];
  gtag?: GtagFn;
};

function decodeJwtSub(jwt: string | null): string | null {
  if (!jwt) return null;
  const parts = jwt.split(".");
  if (parts.length < 2) return null;
  try {
    const segment = parts[1];
    const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
    const pad = (4 - (base64.length % 4)) % 4;
    const padded = base64 + "=".repeat(pad);
    const json = atob(padded);
    const obj = JSON.parse(json) as { sub?: unknown };
    const sub = typeof obj.sub === "string" ? obj.sub.trim() : "";
    return sub || null;
  } catch {
    return null;
  }
}

function getGtag(): GtagFn | null {
  if (typeof window === "undefined") return null;
  const gtag = (window as GtagWindow).gtag;
  return typeof gtag === "function" ? gtag : null;
}

/**
 * Google Ads — conversion после успешной регистрации (не на pageview /register).
 * Вызывать сразу после успешного auth API, до emit/reдиректа.
 */
export function trackGoogleAdsRegistrationConversion(): void {
  const transactionId = decodeJwtSub(readStoredAccessToken()) ?? `geni_${Date.now()}`;
  getGtag()?.("event", "conversion", {
    send_to: GOOGLE_ADS_SEND_TO,
    value: 1.0,
    currency: "USD",
    transaction_id: transactionId,
  });
}
